import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/forum";

export default function CategoryTabs() {
  const location = useLocation();
  const currentSlug = location.pathname.split("/category/")[1] || "";

  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-1 scrollbar-hide flex-wrap">
      <Link
        to="/"
        className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
          !currentSlug
            ? "bg-primary-500 text-background-50"
            : "bg-background-100 text-foreground-600 hover:bg-background-200"
        }`}
      >
        全部
      </Link>
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`/category/${cat.slug}`}
          className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
            currentSlug === cat.slug
              ? "bg-primary-500 text-background-50"
              : "bg-background-100 text-foreground-600 hover:bg-background-200"
          }`}
        >
          <i className={`${cat.icon} mr-1.5 text-xs`}></i>
          {cat.name}
        </Link>
      ))}
    </div>
  );
}